module.exports = __webpack_public_path__ + "static/img/ic_apple@4x.8b8d6fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_apple@4x.png
// module id = x2ad
// module chunks = 1